export const SubDownArr = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16 10L12 14L8 10" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
